























import { UiTooltip } from './keen-ui';
import Loader from './loader.component.vue';

export default {
  name: 'epb-button',
  components: {
    Loader,
    UiTooltip
  },
  props: {
    type: { // solid (with background), void (borders & text), borderless (only text)
      type: String,
      default: 'solid'
    },
    color: {
      type: String,
      default: 'primary'
    },
    size: { // big, small
      type: String,
      default: 'big'
    },
    icon: String,
    iconPosition: { // left, right
      type: String,
      default: 'left'
    },
    tooltip: String,
    tooltipPosition: { // top, bottom, left, right (all of them can be concatenated with '-start' or '-end')
      type: String,
      default: 'top'
    },
    disabled: Boolean,
    loading: Boolean
  },
  computed: {
    buttonClasses: function (): string[] {
      const classes = [
        `epb-button--${ this.type }`,
        `epb-button--${ this.color }`,
        `epb-button--${ this.size }`
      ];
      if (this.disabled) {
        classes.push('epb-button--disabled');
      }
      if (this.loading) {
        classes.push('epb-button--loading');
      }
      return classes;
    }
  }
};
